import { render, staticRenderFns } from "./myChat.vue?vue&type=template&id=23aa2a7e&scoped=true"
import script from "./myChat.vue?vue&type=script&lang=js"
export * from "./myChat.vue?vue&type=script&lang=js"
import style0 from "./myChat.vue?vue&type=style&index=0&id=23aa2a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa2a7e",
  null
  
)

export default component.exports